import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: ''
};

export const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload
        },
        clearError: (state) => {
            state.error = initialState.error
        }
    }
});

//Export akcji powiązanych z reducerem.
export const { setError, clearError } = errorSlice.actions;

//Selector do wyboru danych
export const selectError = (state) => state.error.error;

export default errorSlice.reducer; 